import React, { Component, ErrorInfo, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = {
    hasError: false,
    error: undefined,
  };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('ErrorBoundary caught an error', error, errorInfo);
    // You can log errorInfo to an error reporting service here
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div
            style={{
              padding: '2rem',
            }}
          >
            <div
              style={{
                maxWidth: '500px',
                margin: '40px auto',
                padding: '24px',
                border: '1px solid rgb(202, 202, 202)',
                borderRadius: '8px',
                backgroundColor: 'rgba(242, 242, 242, 0.8)',
                fontFamily: "'Segoe UI', sans-serif",
              }}
            >
              <h2
                style={{
                  marginTop: '0',
                  color: 'rgb(0, 0, 0)',
                  fontSize: '20px',
                }}
              >
                ⚠️ Oops! Something went wrong.
              </h2>
              <p
                style={{
                  color: 'rgb(93, 93, 93)',
                  fontSize: '16px',
                  margin: '12px 0 0 0',
                }}
              >
                Please try again later or contact support if the problem
                persists.
              </p>
              <hr
                style={{
                  margin: '12px 0 0 0',
                  border: '1px solid rgb(224, 224, 224)',
                }}
              />
              <p style={{ color: 'rgb(93, 93, 93)', fontSize: '14px' }}>
                Error Message:
              </p>
              <pre
                style={{
                  whiteSpace: 'pre-wrap',
                  backgroundColor: 'rgba(210, 210, 210, 0.8)',
                  color: 'rgba(0, 0, 0, 0.8)',
                  padding: '12px',
                  borderRadius: '4px',
                  fontSize: '14px',
                  margin: '12px 0 0 0',
                }}
              >
                {this.state.error?.message}
              </pre>
            </div>
          </div>
        )
      );
    }

    return this.props.children;
  }
}
